export default {
  getTasks(state){
    return state.tasks;
  },

  isLoaded(state){
    return state.loadedProjectId;
  }
  
};
